import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] grid-pattern flex items-center justify-center px-6">
      <div className="max-w-md w-full border border-white/10 bg-[#0F0F0F] p-10 text-center">
        <XCircle className="w-12 h-12 text-[#FF3B30] mx-auto mb-6" strokeWidth={1.5} />
        <h1 className="font-display text-3xl font-bold tracking-tight mb-2">Payment cancelled</h1>
        <p className="text-neutral-400 text-sm mb-8">No charge was made. You can try again anytime.</p>
        <Link to="/pricing" className="block bg-white text-black py-3 text-xs uppercase tracking-widest font-semibold hover:bg-neutral-200">
          Back to pricing
        </Link>
      </div>
    </div>
  );
}
